import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26 26",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "none",
		strokeMiterlimit: 10,
		strokeWidth: 2.08,
		d: "M9,4.429V3c0-1.421,0.619-2,2-2h4 c1.381,0,2,0.579,2,2v1.429"
	}), /* @__PURE__ */ _jsx("path", { d: "M23 4L23 4c0-.551-.449-1-1-1H4C3.449 3 3 3.449 3 4l0 0H2v2h22V4H23zM4 7v16c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V7H4zM10 22H8V10h2V22zM14 22h-2V10h2V22zM18 22h-2V10h2V22z" })]
});
export default SvgTrash;
